module.exports = __webpack_public_path__ + "img/ico_sac.90e4fde5.svg";